export type ScreenSoundType = 1 | 2 | 3;

interface IScreenSoundTypeEnum {
    None: ScreenSoundType;
    Ring: ScreenSoundType;
    Spelling: ScreenSoundType;
    format(value: number): string | undefined;
    displayTypesArray(): any[];
}

const dataSource = () => [{ key: 1, text: 'Jokio garso' }, { key: 2, text: 'Skambėjimas' }, { key: 3, text: 'Bilietėlio numerio sakymas' }];

export const screenSoundType: IScreenSoundTypeEnum = {
    None: 1,
    Ring: 2,
    Spelling: 3,
    format(value: number) {
        const item = dataSource().find(x => x.key === value);
        return item && item.text;
    },
    displayTypesArray() {
        let types: any[] = [];
        dataSource().map(x => {
            types.push(x);
        });
        return types;
    }
};
